import Logo from '@/components/base/Logo';

export default function Footer() {
  return (
    <footer className="bg-midnight-dark border-t border-copper/5">
      <div className="max-w-5xl mx-auto px-6 py-14 md:py-20 text-center">
        <div className="flex justify-center mb-6">
          <Logo size="lg" variant="copper" />
        </div>

        <p className="font-display text-lg md:text-xl text-cream/60 mb-3">
          We look forward to celebrating with you
        </p>

        <div className="flex items-center justify-center gap-3 mb-8">
          <span className="w-8 h-px bg-copper/15" />
          <i className="ri-heart-3-line text-copper/25 w-4 h-4 flex items-center justify-center" />
          <span className="w-8 h-px bg-copper/15" />
        </div>

        <p className="font-sans text-xs text-pearl/30 tracking-wider">
          Sharoof &amp; Adhabiya &middot; June 6, 2026
        </p>
      </div>
    </footer>
  );
}